import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';

import { usePaymentHistoryCxc } from '../hooks/usePaymentHistoryCxc';

import PaymentHistoryTableSection from './sections/PaymentHistoryTableSection';
import PaymentHistorySummarySection from './sections/PaymentHistorySummarySection';
import HistoryCustomerSelector from './HistoryCustomerSelector';
import ButtonCustom from '../../../../pages/UiElements/ButtonCustom';

interface Props {
  receivableId?: number;
}

const PaymentHistoryForm = ({ receivableId }: Props) => {
  const navigate = useNavigate();

  const { history, fetchPaymentHistory, clearHistory } = usePaymentHistoryCxc();

  const isContextMode = !!receivableId;

  useEffect(() => {
    if (!receivableId) return;

    fetchPaymentHistory(receivableId);
  }, [receivableId]);

  const handleBackToBalances = () => {
    clearHistory();

    navigate('/finance/cxc/client-balances');
  };

  if (!isContextMode && !history) {
    return <HistoryCustomerSelector />;
  }

  if (!history) return null;

  return (
    <div>
      {/* 🔹 ENCABEZADO */}
      <div className="flex flex-wrap items-center justify-between gap-4 bg-success/5 px-6 py-5">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-success text-white">
            <Users className="h-5 w-5" />
          </span>
          <div>
            <h2 className="font-semibold text-black dark:text-white">
              Historial de Cobros a Clientes
            </h2>
            <p className="text-sm text-body dark:text-bodydark2">
              Cobros aplicados a esta cuenta por cobrar
            </p>
          </div>
        </div>

        <ButtonCustom
          text="Volver a cuentas por cobrar"
          onClick={handleBackToBalances}
          iconKey="arrowleft"
          variant="success"
          size="sm"
          rounded="md"
          outline
        />
      </div>

      <div className="divide-y divide-stroke dark:divide-strokedark">
        <PaymentHistorySummarySection data={history} />

        <PaymentHistoryTableSection payments={history.payments || []} />
      </div>
    </div>
  );
};

export default PaymentHistoryForm;
